import { createTheme, ThemeProvider } from "@kaggle/styled-components";
import * as React from "react";
import { render } from "react-dom";
import { JupyterLabGlobalStyle } from "../../components/jupyter/JupyterLabGlobalStyle";

const darkTheme = createTheme({
  themeName: "dark",
  sourceType: "notebook",
  experimentalTheme: true,
});

const STYLE_DIV_ID = "kaggle-jupyterlab-style";

export const renderStyle = () => {
  let styleRoot = document.getElementById(STYLE_DIV_ID);
  if (!styleRoot) {
    styleRoot = document.createElement("div");
    styleRoot.id = STYLE_DIV_ID;
    document.body.appendChild(styleRoot);
  }
  render(
    <ThemeProvider theme={darkTheme}>
      <JupyterLabGlobalStyle />
    </ThemeProvider>,
    styleRoot
  );
};
